import React from 'react'

import ProductParagraphMolecule  from '@/molecules/Paragraphs/ProductParagraph'

const ProductParagraph = (props) => (
  <ProductParagraphMolecule {...props} />
)

export default ProductParagraph
